export const getPsychologits = (state) => {
    if (state.psychologitsArray) {
        // return [...state.psychologitsArray];
        return state.psychologitsArray.map(el => ({...el, text: el.name, id: el.psychologist_id}))
    }
    return [];
}